import { ThemeProvider } from "@mui/material/styles";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./app.routes";
import "i18n/config";
import Notification from "shared/components/Notification";
import theme from "styles/theme";
import AppRoutesOnPrem from "./app-routes-on-prem";
import { runtimeConfig } from "@/shared/config/runtime-config-loader";

function App(): JSX.Element {
  return (
    <ThemeProvider theme={theme}>
      <main>
        <Router basename={runtimeConfig.baseHref || "/"}>
          {runtimeConfig.ttsOnPrem ? (
            <AppRoutesOnPrem />
          ) : (
            <AppRoutes />
          )}
        </Router>
        <Notification />
      </main>
    </ThemeProvider>
  );
}

export default App;
